import { API_URL, getAuthHeaders } from './config';

export const calendarService = {
    getAuthUrl: async (provider: 'google' | 'outlook', redirectUrl: string) => {
        const res = await fetch(`${API_URL}/auth/calendar/url?provider=${provider}&redirect_url=${encodeURIComponent(redirectUrl)}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to get auth URL");
        }
        return res.json() as Promise<{ url: string }>;
    },

    exchangeCode: async (provider: 'google' | 'outlook', code: string, redirectUrl: string) => {
        const res = await fetch(`${API_URL}/auth/calendar/callback`, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ provider, code, redirect_url: redirectUrl })
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to exchange code");
        }
        return res.json() as Promise<{ message: string }>;
    },

    disconnect: async () => {
        const res = await fetch(`${API_URL}/auth/calendar/disconnect`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Failed to disconnect");
        }
        return res.json() as Promise<{ message: string }>;
    },
    forceSync: async () => {
        const res = await fetch(`${API_URL}/auth/calendar/sync`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
        const data = await res.json() as any;
        if (!res.ok) {
            throw new Error(data.error || "Failed to sync");
        }
        return data as { message: string, matches_synced: number, tournaments_synced: number, errors?: string[] };
    }
};
